// Maps a failed /api/auth/login ApiError to what the login form should do next:
// ask for an authenticator code, and/or show a message.
export function describeLoginError(err, code) {
  const body = err?.body ?? {};
  if (err?.status === 429) {
    const mins = Math.max(1, Math.ceil((body.retryAfter ?? 60) / 60));
    return { twoFactorRequired: Boolean(code), error: `Too many attempts. Try again in ${mins} min.` };
  }
  if (body.codeReused) {
    return { twoFactorRequired: true, error: 'That code was just used. Wait for the next one.' };
  }
  if (body.twoFactorRequired) {
    return { twoFactorRequired: true, error: code ? 'That code did not work.' : '' };
  }
  if (err?.status === 401) return { twoFactorRequired: false, error: 'Incorrect password' };
  return { twoFactorRequired: false, error: 'Could not reach the server.' };
}
